import { render, staticRenderFns } from "./settings-dropdown.vue?vue&type=template&id=a7f23922&scoped=true&"
import script from "./settings-dropdown.vue?vue&type=script&lang=js&"
export * from "./settings-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./settings-dropdown.vue?vue&type=style&index=0&id=a7f23922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f23922",
  null
  
)

export default component.exports